<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="130px">
        <el-form-item label="名称" class="addAdminForm">
          <el-input v-model="editData.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="简介" class="addAdminForm">
          <el-input v-model="editData.info" placeholder="请输入简介"></el-input>
        </el-form-item>
        <el-form-item label="缩略图:列表左侧" class="addAdminForm">
          <el-input v-model="editData.pic1" placeholder="请输入缩略图:列表左侧"></el-input>
        </el-form-item>
        <el-form-item label="缩略图:详情右侧" class="addAdminForm">
          <el-input v-model="editData.pic2" placeholder="请输入缩略图:详情右侧"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      honortypeList: [],
      editData: {
        id: '0',
        name: '',
        info: '',
        pic1: '',
        pic2: ''
      }
    }
  },
  mounted () {
    this.honortypeList = Vue.prototype.FunGetHonortype()
  },
  methods: {
    LoadData (row) {
      this.editData.id = row.Id
      this.editData.name = row.Name
      this.editData.info = row.Info
      this.editData.pic1 = row.Pic1
      this.editData.pic2 = row.Pic2
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditKgjtWebsiteSubsidiaryCompany()
    },
    EditKgjtWebsiteSubsidiaryCompany: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        name: that.editData.name,
        info: that.editData.info,
        pic1: that.editData.pic1,
        pic2: that.editData.pic2
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteSubsidiaryCompany, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
